"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iframe = void 0;
var react_1 = __importStar(require("react"));
function Iframe(_a) {
    var url = _a.url, onLoad = _a.onLoad;
    var iframeRef = (0, react_1.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onLoadHandler(event) {
        onLoad(event, iframeRef);
    }
    return (react_1.default.createElement("iframe", { ref: iframeRef, src: url, onLoad: onLoadHandler, "data-testid": "iframe", style: { width: '100%', height: '100%', border: '0 none' }, title: "iframe-component" }));
}
exports.Iframe = Iframe;
